import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Slider from '../../components/Slider/Slider';
import Logo from '../../components/logo/logo';
import './home.css';

const Home = () => {
  const [openAccordion, setOpenAccordion] = useState(null);
  const [boxHeights, setBoxHeights] = useState({});
  const accordionRefs = useRef({});

  const toggleAccordion = (boxIndex, accordionIndex) => {
    const id = `${boxIndex}-${accordionIndex}`;
    setOpenAccordion(openAccordion === id ? null : id);
  };

  const data = [
    {
      title: 'Jasa Software Development',
      description: 'Wujudkan ide Anda menjadi solusi nyata.',
      accordionContent: [
        'Detail lengkap tentang Jasa Software Development.',
        'Layanan tambahan seperti integrasi dan pemeliharaan.',
        'Keuntungan dari layanan kami.',
      ],
      accordionTitles: [
        'Detail Jasa Pengembangan',
        'Layanan Tambahan',
        'Keuntungan Layanan'
      ],
      link: '/product-1',
    },
    {
      title: 'IT Talent Team',
      description: 'Butuh tim IT handal? Kami siap membantu.',
      accordionContent: [
        'Kami menyediakan tim IT profesional.',
        'Fleksibilitas dalam memilih spesialisasi.',
        'Dukungan teknis siap membantu.',
      ],
      accordionTitles: [
        'Tim Profesional IT',
        'Fleksibilitas Spesialisasi',
        'Dukungan Teknis'
      ],
      link: '/product-2',
    },
    {
      title: 'Global Development Center',
      description: 'Pengembangan sistem global untuk bisnis Anda.',
      accordionContent: [
        'Solusi pengembangan sistem global yang dirancang khusus.',
        'Skalabilitas untuk mendukung pertumbuhan bisnis Anda.',
        'Keamanan data tingkat tinggi untuk melindungi aset Anda.',
      ],
      accordionTitles: [
        'Solusi Pengembangan Sistem Global',
        'Skalabilitas dan Pertumbuhan Bisnis',
        'Keamanan Data untuk Perlindungan Aset'
      ],
      link: '/product-3',
    },
  ];

  useEffect(() => {
    const newHeights = {};
    data.forEach((item, boxIndex) => {
      let totalHeight = 223;
      item.accordionContent.forEach((_, accordionIndex) => {
        const id = `${boxIndex}-${accordionIndex}`;
        if (openAccordion === id) {
          const accordionHeight = accordionRefs.current[id]?.scrollHeight || -10;
          totalHeight += accordionHeight;
        }
      });
      newHeights[boxIndex] = totalHeight;
    });
    setBoxHeights(newHeights);
  }, [openAccordion]);

  return (
    <div className="home-container">
      <Slider />
      <div className="home-text">
        <h2>Solusi IT Terbaik untuk Bisnis Anda!</h2>
        <p>
          Kami menyediakan solusi IT lengkap dan efektif, mulai dari pengembangan perangkat lunak,
          penyediaan tim IT profesional, hingga pengembangan sistem global untuk memenuhi kebutuhan
          bisnis Anda.
        </p>
      </div>
      <Logo />

      <div className="content-grid">
        {data.map((item, boxIndex) => (
          <div className={`content-row ${boxIndex % 2 === 0 ? 'left' : 'right'}`} key={boxIndex}>
            <div className="content-box" style={{ height: boxHeights[boxIndex] || 180 }}>
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </div>

            <div className="accordion-container">
              {item.accordionContent.map((content, accordionIndex) => {
                const id = `${boxIndex}-${accordionIndex}`;
                return (
                  <div
                    className={`accordion ${openAccordion === id ? 'open' : ''}`}
                    key={id}
                    ref={el => accordionRefs.current[id] = el}
                  >
                    <div className="accordion-header" onClick={() => toggleAccordion(boxIndex, accordionIndex)}>
                      <span>{item.accordionTitles[accordionIndex]}</span>
                      <span>{openAccordion === id ? '▲' : '▼'}</span>
                    </div>
                    {openAccordion === id && (
                      <div className="accordion-body">
                        <p>{content}</p>
                        <div className="accordion-button-container">
                          <Link to={item.link}>
                          </Link>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>

      <div className="about-us">
        <div className="about-text">
          <h3>Tentang Kami</h3>
          <p>
            PT MARS ACME PERKASA adalah mitra terpercaya untuk semua kebutuhan manufaktur industri Anda.
            Dengan pemahaman yang mendalam tentang permintaan pasar, kami berkomitmen untuk menyediakan
            solusi komprehensif yang mendukung kesuksesan Anda.
            Kami memiliki reputasi baik dengan banyak pemasok lokal, sehingga kami dapat menyediakan berbagai
            jenis produk peralatan dengan kualitas terjamin dan harga yang kompetitif.
          </p>
        </div>
        <div className="about-image">
          <img src="api.jpeg" alt="Tentang Kami" />
        </div>
      </div>
    </div>
  );
};

export default Home;